import { mediaSrc } from "./mediaSrc";

const EMPTY = { product_ads: [], characters: [], music: [] };

/**
 * Parse homepage_showcase_json from web_public.
 * @param {string|object|null} raw
 */
export function parseHomepageShowcase(raw) {
  if (!raw) return { ...EMPTY };
  try {
    const data = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!data || typeof data !== "object") return { ...EMPTY };
    const norm = (arr) =>
      (Array.isArray(arr) ? arr : [])
        .map((item) => {
          if (!item || typeof item !== "object") return null;
          const title = String(item.title || "").trim();
          const url = String(item.url || item.link || "").trim();
          const media = String(item.media_url || item.mediaUrl || item.thumbnail || "").trim();
          const audio = String(item.audio_url || item.audioUrl || "").trim();
          if (!title && !url && !media && !audio) return null;
          let type = String(item.type || "").toLowerCase();
          if (!type) {
            if (/\.(mp4|webm|mov)(\?|$)/i.test(media)) type = "video";
            else if (/\.(mp3|wav|ogg|m4a)(\?|$)/i.test(audio)) type = "audio";
            else type = "image";
          }
          return {
            title: title || "Sample",
            url,
            media_url: media ? mediaSrc(media) : "",
            audio_url: audio ? mediaSrc(audio) : "",
            type,
          };
        })
        .filter(Boolean);
    const music = norm(data.music).map((item) => {
      const media = /favicon/i.test(item.media_url) ? "" : item.media_url;
      const type =
        item.audio_url || item.type === "audio" ? "audio" : item.type;
      return { ...item, media_url: media, type };
    });
    return {
      product_ads: norm(data.product_ads),
      characters: norm(data.characters),
      music,
    };
  } catch {
    return { ...EMPTY };
  }
}

export function showcaseHasItems(showcase) {
  if (!showcase) return false;
  return (
    showcase.product_ads?.length > 0 ||
    showcase.characters?.length > 0 ||
    showcase.music?.length > 0
  );
}
